const PathConstants = {
  Home: "https://www.getclaimable.com/",
  Root: "/",

  // Account
  AccountOverview: "/account",
  Appeals: "/appeals",
  MyAppeals: "/my-appeals",
  MyAppealsAccount: "/my-appeals/account",
  MyAppealsEligibility: "/my-appeals/eligibility",
  MagicLinkUpheldFollowUp: "/my-appeals/magic-link-upheld-follow-up",

  MyAppealsDetail: "/my-appeals/:appealId",
  MyAppealsInsurance: "/my-appeals/:appealId/insurance",
  MyAppealsInsurancePrimaryEnrollee:
    "/my-appeals/:appealId/insurance/primary-enrollee",
  MyAppealsInsuranceDenyingParty:
    "/my-appeals/:appealId/insurance/denying-party",
  MyAppealsInsuranceUploadCard: "/my-appeals/:appealId/insurance/upload-card",
  MyAppealsPatientInfo: "/my-appeals/:appealId/patient-info",
  MyAppealsDenialReason: "/my-appeals/:appealId/denial-reason",
  MyAppealsDenialReasonSubDenialReason:
    "/my-appeals/:appealId/denial-reason/sub-denial-reason",
  MyAppealsDenialReasonAlternativeCondition:
    "/my-appeals/:appealId/denial-reason/alternative-condition",
  MyAppealsDenialReasonBmiCriteriaFollowUp:
    "/my-appeals/:appealId/denial-reason/bmi-criteria-follow-up",
  MyAppealsDenialReasonOtherAppealSituations:
    "/my-appeals/:appealId/denial-reason/other-appeal-situations",
  MyAppealsSurveyLegacy: "/my-appeals/:appealId/survey-legacy",
  MyAppealsSurvey: "/my-appeals/:appealId/survey",
  MyAppealsDocuments: "/my-appeals/:appealId/documents",
  MyAppealsFinalizePatientDestination:
    "/my-appeals/:appealId/finalize/patient-destination",
  MyAppealsFinalizeEmployerDestination:
    "/my-appeals/:appealId/finalize/employer-destination",
  MyAppealsFinalizeAppealDestination:
    "/my-appeals/:appealId/finalize/appeal-destination",
  MyAppealsFinalizeCcDestinations:
    "/my-appeals/:appealId/finalize/cc-destinations",
  MyAppealsFinalizePrePayment: "/my-appeals/:appealId/finalize/pre-payment",
  MyAppealsFinalizeReadyToSubmit:
    "/my-appeals/:appealId/finalize/ready-to-submit",
  MyAppealsFinalizeReviewAppeal: "/my-appeals/:appealId/finalize/review-appeal",
  MyAppealsFinalizePurchaseComplete:
    "/my-appeals/:appealId/finalize/purchase-complete",

  MyAppealsGenerateLetter:
    "/my-appeals/:appealId/generate-and-review/generate-letter",
  MyAppealsGenerateReviewLetter:
    "/my-appeals/:appealId/generate-and-review/review-letter",

  // Report Status Flow (under my-appeals/:appealId)
  MyAppealsReportStatus: "/my-appeals/:appealId/report-status",
  MyAppealsReportStatusUploadApprovalLetter:
    "/my-appeals/:appealId/report-status/upload-approval-letter",
  MyAppealsReportStatusAppealWon:
    "/my-appeals/:appealId/report-status/appeal-won",
  MyAppealsReportStatusReviewAndShare:
    "/my-appeals/:appealId/report-status/review-and-share",
  MyAppealsReportStatusDenialUpheld:
    "/my-appeals/:appealId/report-status/denial-upheld",
  MyAppealsReportStatusDenialUpheldClaimFile:
    "/my-appeals/:appealId/report-status/denial-upheld-claim-file",
  MyAppealsReportStatusAppealLost:
    "/my-appeals/:appealId/report-status/appeal-lost",

  // Report Appeal Result Flow (legacy paths - kept for redirects)
  ReportAppealResult: "/report-appeal-result/:appealId",
  AppealWon: "/appeal-won",
  UploadApprovalLetter: "/upload-approval-letter/:appealId",
  ReviewAndShare: "/review-and-share",
  NoResultNotEnoughTime: "https://www.getclaimable.com/have-you-heard-back",
  NoResultShouldHaveHeardBack:
    "https://www.getclaimable.com/should-have-heard-back",
  DenialUpheld: "/denial-upheld/:appealId",
  DenialUpheldClaimFile: "/denial-upheld-claim-file/:appealId",
  AppealLost: "/appeal-lost",
  NotifyMe: "https://www.getclaimable.com/notify-me",

  // Eligibility Flow

  CoverageFundQualify: "/coverage-fund-qualify",
  CoverageFundEligibility: "/coverage-fund-eligibility",
  MedicationConditionEligibility: "/medication-condition-eligibility",
  DenialReasonEligibility: "/denial-reason-eligibility",
  SubDenialReasonEligibility: "/sub-denial-reason-eligibility",
  AlternativeConditionEligibility: "/alternative-condition-eligibility",
  BMICriteriaFollowUp: "/bmi-criteria-follow-up",
  WhoIsAppealFor: "/who-is-appeal-for",
  PatientInfo: "/patient-info",
  CoverageFundNotQualify: "/coverage-fund-not-qualify",
  NotifyMeDenial: "https://www.getclaimable.com/notify-me-denial",
  SucraidRedirect: "https://partners.getclaimable.com/sucraid",
  StrensiqRedirect: "https://partners.getclaimable.com/strensiq",

  NotFound: "*",

  // Resume

  ResumeAppeal: "/resume-appeal/:appealId",

  UpdateAppealStatus: "/update-appeal-status/:encryptedToken",
};

export default PathConstants;
